import {StateCreator} from 'zustand'
import {TProjectSector} from '../types/project.type'

type State = {subSectors: (TProjectSector | null)[]}
type Action = {setSubSectors: (subSectors: (TProjectSector | null)[]) => void}
export type SubSectorSlice = State & Action

const createSubSectorSlice: StateCreator<SubSectorSlice> = set => ({
  subSectors: [],
  setSubSectors: subSectors => set({subSectors: subSectors}),
})

export default createSubSectorSlice
